import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {sx} from './sx'
import UserAccessRoot from "@containers/account/access/userAccess/UserAccessRoot";
import {ACCESS_KEYS_VOYAGE_VIEW} from "@containers/account/access/constants/accessList/voyage";
import {VoyagePlanningWidthLocalStateLazy} from "@containers/voyagePlanning/VoyagePlanningWithLocalState.lazy";

const VoyagePlanningWithLocalStatePage = () => {
    return (
        <PageLayout
            sx={sx.root}
        >
            {/* Same as VoyagePlanningPage: READ opens the grid, planning is gated inside. */}
            <UserAccessRoot
                accessType={'or'}
                keys={ACCESS_KEYS_VOYAGE_VIEW}
            >
                <Suspense
                    fallback={<SpinnerCustom/>}
                >
                    <VoyagePlanningWidthLocalStateLazy/>
                </Suspense>
            </UserAccessRoot>
        </PageLayout>
    )
};

export default VoyagePlanningWithLocalStatePage;
